import React from "react";
import styled from "styled-components";
import Image from "react-bootstrap/Image";

const Passport = ({ data }) => {
  const otherData = data?.other_data;

  return (
    <Wrapper>
      <Image src="/cards/passport.png" className="wrapper__background" />
      <div className="content">
        <div className="content__item content__image">
          <Image src={`data:image/png;base64, ${data?.picture}`} />
        </div>
        <div className="content__item content__photo">
          <Image src={`data:image/png;base64, ${data?.picture}`} />
        </div>
        <p className="content__item content__type">{data?.type || ""}</p>
        <p className="content__item content__country-code">
          {data?.country_code || ""}
        </p>
        <p className="content__item content__passport-no">
          {data?.id_number || ""}
        </p>
        <p className="content__item content__surname">
          {otherData?.LastName || data?.last_name || ""}
        </p>
        <p className="content__item content__given-name">
          {`${otherData?.FirstName || data?.first_name || ""} ${
            otherData?.MiddleName || data?.othername || ""
          }`}
        </p>
        <p className="content__item content__nationality">
          {otherData?.Nationality || data?.nationality || ""}
        </p>
        <p className="content__item content__date-of-birth">
          {otherData?.DateOfBirth || data?.date_of_birth || ""}
        </p>
        <p className="content__item content__sex">
          {data?.sex || data?.gender || ""}
        </p>
        <p className="content__item content__place-of-birth">
          {otherData?.PlaceOfBirth || data?.place_of_birth || ""}
        </p>
        <p className="content__item content__date-of-issue">
          {data?.registration_date || ""}
        </p>
        <p className="content__item content__place-of-issue">
          {otherData?.PlaceOfIssue || data?.place_of_issue || ""}
        </p>
        <p className="content__item content__expiry">
          {otherData?.ExpiryDate || data?.expiry_date || ""}
        </p>
        <p className="content__item content__authority">PASSPORT OFFICE</p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 290px;
  height: 190px;
  position: relative;
  img.wrapper__background {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    &__image {
      top: 29px;
      left: 4px;
      width: 74px;
      height: 108px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__photo {
      top: 41px;
      left: 205px;
      width: 27px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__item {
      color: #000;
      font-size: 6px;
      font-weight: 500;
      line-height: 7px;
      position: absolute;
      text-transform: uppercase;
    }
    &__type {
      top: 27px;
      left: 87px;
    }
    &__country-code {
      top: 27px;
      left: 131px;
    }
    &__passport-no {
      top: 27px;
      left: 218px;
    }
    &__surname {
      top: 42px;
      left: 87px;
    }
    &__given-name {
      top: 56px;
      left: 87px;
    }
    &__nationality {
      top: 70px;
      left: 87px;
    }
    &__date-of-birth {
      top: 84px;
      left: 87px;
    }
    &__sex {
      top: 98px;
      left: 87px;
    }
    &__place-of-birth {
      top: 98px;
      left: 126px;
    }
    &__date-of-issue {
      top: 112px;
      left: 87px;
    }
    &__place-of-issue {
      top: 112px;
      left: 207px;
    }
    &__expiry {
      top: 126px;
      left: 87px;
    }
    &__authority {
      top: 126px;
      left: 207px;
    }
  }
`;

export default Passport;
